module.exports = __webpack_public_path__ + "static/media/logo.403dbfdc.png";